import { useEffect, useState } from "react";
import { getNauticalImage } from "../../../utils/nfsUtils";
import { toast } from "react-toastify";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import Graphic from "@arcgis/core/Graphic";
import { useDispatch } from "react-redux";

import { setNauticalImageContext } from "../../../store/appSlice";

interface NauticalImageButtonProps {
    feature: Graphic | null;
}

const NauticalImageButton = (props: NauticalImageButtonProps) => {
    const dispatch = useDispatch();
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const buttonTextDefault = "Vis nautisk bilde";
    const [buttonText, setButtonText] = useState(buttonTextDefault);

    const fetchImage = async (gisObjId: number) => {
        try {
            const { url, notFound } = await getNauticalImage(gisObjId);

            if (notFound) {
                toast.info("Ingen nautisk bilde tilgjengelig.");
                setButtonText("Ingen nautisk bilde tilgjengelig");
                return;
            }

            if (!url) {
                toast.error("Kunne ikke hente bildet.");
                setButtonText(buttonTextDefault);
                return;
            }

            const imageContext = {
                open: true,
                sjomerkeNr: props.feature?.attributes?.sjomerke_nr,
                imageUrl: url,
            };
            dispatch(setNauticalImageContext(imageContext));

            setButtonText(buttonTextDefault);
            setButtonDisabled(false);
        } catch (error) {
            console.error("Failed to fetch nautical image:", error);
            toast.error("Feil ved henting av bildet.");
            setButtonText(buttonTextDefault);
            setButtonDisabled(false);
        }
    };

    useEffect(() => {
        dispatch(setNauticalImageContext({ open: false, sjomerkeNr: null, imageUrl: null }));

        const gisObjId = props.feature?.attributes?.gis_obj_id;
        if (!gisObjId) {
            setButtonDisabled(true);
            setButtonText("Ingen nautisk bilde tilgjengelig");
        } else {
            setButtonDisabled(false);
            setButtonText(buttonTextDefault);
        }
    }, [props.feature]);

    function showNauticalImageButtonClick(): void {
        setButtonDisabled(true);
        setButtonText(`Henter bilde for ${props.feature?.attributes?.sjomerke_nr} ...`);
        fetchImage(props.feature?.attributes?.gis_obj_id);
    }

    return (
        <NfsButton onClick={showNauticalImageButtonClick} disabled={buttonDisabled} outlined>
            {buttonText}
        </NfsButton>
    );
};

export default NauticalImageButton;
